import Dialog from "../../../1. Core/Controls/Dialog/Dialog";
import TextField from "../../../1. Core/Controls/TextField/TextField";
import NP from "../../../1. Core/NP";
import {FighterCardWidgetMetadata, IAthlete, Widget} from "../../types";
import {ServerAPI} from "../../../1. Core/ServerAPI";
import {WidgetType} from "../WEnum";
import SelectFighterCtrl from "../../../2. Athletes/SelectFighterCtrl";
import Select from "../../../1. Core/Controls/Select/Select";
import ColorPicker from "../../../1. Core/Controls/ColorPicker/ColorPicker";
import ImageTextField from "../../../1. Core/Controls/TextField/ImageTextField";


export default class FighterCardWidgetEditDialog extends Dialog {
	private _name: TextField;

	private _backgoundUrlInput: ImageTextField;
	private _logoUrlInput: ImageTextField;
	private _photoUrlInput: ImageTextField;

	private _Widget: Widget<FighterCardWidgetMetadata>;

	private _previewFrame: HTMLFrameElement;
	private _timeId: any;


	private _title1: TextField;

	private _selectFighter: SelectFighterCtrl;
	private _periodType: Select;
	private _fontCombo: Select;
	private _fontColor: ColorPicker;
	private fromYear: Select;
	private toYear: Select;
	private _SelectedAthlete: IAthlete;


	_initFields(settings: object)
	{
		this._SelectedAthlete = null
		this._Widget = null;
		super._initFields(settings);
		this._Mode = 'FullHeight';
		this._Caption = NP.RM.getString('FighterCardStatWidget');
		this._CloseOnFrameMouseDown = true;
		this._ShowHeader = true;
		this._ShowCloseButton = true;
		this._OkRK = 'Save'
		this._AutoDestroy = true;
		this._Width = 1700;
	}

	_render()
	{
		super._render();

		let flexNode = NP.createNode(this._contentNode, 'widget-dlg-content-node')
		let leftNode = NP.createNode(flexNode, 'widget-dlg-settings-node')
		this._contentDomNode.style.maxWidth = '1700px'

		this._name = new TextField({
			FloatingLabel: NP.RM.getString('Name'),
			ParentNode: leftNode
		});

		this._selectFighter = new SelectFighterCtrl({
			ParentNode: leftNode,
			FloatingLabel: NP.RM.getString('Athlete'),
			EvSelected: () => this.onSettingsChanged()
		})

		this._photoUrlInput = new ImageTextField({
			TextFieldSettings: {FloatingLabel: NP.RM.getString('PhotoUrl')},
			ParentNode: leftNode,
			EvChanged: () => this.onSettingsChanged()
		});

		this._title1 = new TextField({
			FloatingLabel: "Title",
			ParentNode: leftNode,
			EvChanging: () => this.onSettingsChanged()
		});


		this._periodType = new Select({
			FloatingLabel: NP.RM.getString('PeriodType'),
			ParentNode: leftNode,
			Items: [
				{RK: 'All', Value: 'All'},
				{RK: 'Period', Value: 'Period'}
			],
			Value: 'All',
			EvItemSelected: () =>
			{
				switch (this._periodType.getValue())
				{
					case 'Period':
						this.fromYear.setIsVisible(true);
						this.toYear.setIsVisible(true);
						break;
					case 'All':
						this.fromYear.setIsVisible(false);
						this.toYear.setIsVisible(false);
						break;
				}

				this.onSettingsChanged();
			}
		})

		this.fromYear = new Select({
			ParentNode: leftNode,
			FloatingLabel: NP.RM.getString('From'),
			EvItemSelected: () => this.onSettingsChanged(),
			Items: this.createYearsArray()
		});

		this.toYear = new Select({
			ParentNode: leftNode,
			FloatingLabel: NP.RM.getString('To'),
			EvItemSelected: () => this.onSettingsChanged(),
			Items: this.createYearsArray()
		});


		this._backgoundUrlInput = new ImageTextField({
			TextFieldSettings: {FloatingLabel: NP.RM.getString('Background')},
			ParentNode: leftNode,
			EvChanged: () => this.onSettingsChanged()
		});

		this._fontCombo = new Select({
			ParentNode: leftNode,
			Value: 'Muller',
			Items: [
				{Content: 'Muller', Value: 'Muller'},
				{Content: 'Roboto', Value: 'Roboto'},
				{Content: 'Corbert', Value: 'Corbert'},
				{Content: 'Bourgeois', Value: 'Bourgeois'},
				{Content: 'Swis', Value: 'Swis721 Blk BT'},
				{Content: 'PF Din Text Comp Pro', Value: 'PF Din Text Comp Pro'}
			],
			FloatingLabel: NP.RM.getString('FontFamily'),
			EvItemSelected: () => this.onSettingsChanged()
		});

		this._fontColor = new ColorPicker({
			ParentNode: leftNode,
			FloatingLabel: NP.RM.getString('FontColor'),
			EvColorChanged: () => this.onSettingsChanged()
		})


		this._logoUrlInput = new ImageTextField({
			TextFieldSettings: {FloatingLabel: NP.RM.getString('Logo')},
			ParentNode: leftNode,
			EvChanged: () => this.onSettingsChanged()
		});


		this._previewFrame = NP.createNode(flexNode, '', 'iframe');

		if (this._Widget)
		{
			this._selectFighter.setValue(this._Widget.Metadata.FighterId)
			this._photoUrlInput.setValue(this._Widget.Metadata.PhotoUrl)

			this._name.setValue(this._Widget.Name)
			this._title1.setValue(this._Widget.Metadata.Title1)

			this._backgoundUrlInput.setValue(this._Widget.Metadata.Background)

			this._logoUrlInput.setValue(this._Widget.Metadata.Logo)
			this._fontColor.setValue(this._Widget.Metadata.FontColor || 'black')

			this._fontCombo.setValue(this._Widget.Metadata.FontFamily || 'Muller')

			if (this._Widget.Metadata.ToYear || this._Widget.Metadata.FromYear)
			{
				this._periodType.setValue('Period')
				this.fromYear.setValue(this._Widget.Metadata.FromYear);
				this.toYear.setValue(this._Widget.Metadata.ToYear);
			}
			else
			{
				this._periodType.setValue('All')
			}
		}
		else
			this._periodType.setValue('All')


		if (!this._Widget)
		{
			this._Widget = {
				Metadata: {WId: WidgetType.FighterCard}
			} as Widget<FighterCardWidgetMetadata>

			if (this._SelectedAthlete)
			{
				this._selectFighter.setValue(this._SelectedAthlete.Id)
				this._name.setValue(`FIGHTER CARD ${this._SelectedAthlete.LastName}`)
				this._backgoundUrlInput.setValue('#eee')
			}
		}
		this.refresh()
	}

	createYearsArray()
	{
		let startYear = 1990;
		let arr = [];
		let cYear = new Date().getFullYear();

		for (let y = startYear; y <= cYear; y++)
		{
			arr.push({
				Content: y,
				Value: y
			})
		}
		return arr;
	}

	onSettingsChanged()
	{
		if (this._timeId)
			clearTimeout(this._timeId);

		this._timeId = setTimeout(() => this.updatePreview(), 200);
	}

	updateObjSettings()
	{
		this._Widget.Name = this._name.getValue()
		this._Widget.Metadata.FighterId = this._selectFighter.getValue();
		this._Widget.Metadata.PhotoUrl = this._photoUrlInput.getValue()

		this._Widget.Metadata.Title1 = this._title1.getValue();

		this._Widget.Metadata.Background = this._backgoundUrlInput.getValue()
		this._Widget.Metadata.Logo = this._logoUrlInput.getValue()
		this._Widget.Metadata.FontFamily = this._fontCombo.getValue()


		this._Widget.Metadata.FontColor = this._fontColor.getValue()

		switch (this._periodType.getValue())
		{
			case 'Period':
				this._Widget.Metadata.FromYear = this.fromYear.getValue()
				this._Widget.Metadata.ToYear = this.toYear.getValue()
				break;
			case 'All':
				this._Widget.Metadata.FromYear = null;
				this._Widget.Metadata.ToYear = null;
				break;
		}
	}

	updatePreview()
	{
		this.updateObjSettings();

		if (this._Widget.Metadata.FighterId)
			this._previewFrame.src = `/cwidget/fighter-card?id=${this._Widget.UrlId || -1}&lang=${NP.getCurrentCulture().Name}&json=${encodeURIComponent(JSON.stringify(this._Widget))}`
	}

	async refresh()
	{
		this.updatePreview()
	}


	async _onOkButtonClick()
	{
		this.updateObjSettings();

		if (this._Widget.Id)
			await ServerAPI.callUiApi(`/widget/${this._Widget.Id}`, this._Widget, 'POST');
		else
			await ServerAPI.callUiApi("/widget", this._Widget, 'PUT')


		this.EvOkButtonClick.fire(this);
		this.hide();
	}
}